import script from "./SpareComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./SpareComponents.vue?vue&type=script&setup=true&lang=js"

import "./SpareComponents.vue?vue&type=style&index=0&id=20fb0943&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20fb0943"]])

export default __exports__